import { render } from "./DistributorPayoutsPage.vue?vue&type=template&id=47489650&scoped=true"
import script from "./DistributorPayoutsPage.vue?vue&type=script&lang=js"
export * from "./DistributorPayoutsPage.vue?vue&type=script&lang=js"

import "./DistributorPayoutsPage.vue?vue&type=style&index=0&id=47489650&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47489650"]])

export default __exports__